import React from "react";
import { format } from 'date-fns'
import { Outlet } from "react-router-dom";
import { _now, formatDate } from "../common/dates";
// import MainNav from "./MainNav";
// import { useUser } from "context/userProvider";

const Wrapper = () => {
    // const { user } = useUser();
    const user = null;

    return (
        <div className="min-h-screen w-full bg-gray-900 relative">
            <header>
                <nav aria-label="Global" className="mx-auto flex max-w-7xl items-center justify-between p-6 lg:px-8">
                    <div className="flex lg:flex-1">
                        <a href="#" className="-m-1.5 p-1.5">
                            <span className="sr-only">Your Company</span>
                            <img
                                alt=""
                                src="https://www.kilnworx.com/wp-content/uploads/2016/08/logo-300x63.png"
                                className="h-8 w-auto"
                            />
                        </a>
                    </div>
                </nav>

            </header>
            <Outlet />


            {/* Footer */}
            <footer className="mx-auto mt-24 max-w-7xl px-6 sm:mt-56 lg:px-8">

                <div className="mt-16 border-t border-white/10 pt-8 sm:mt-20 md:flex md:items-center md:justify-between lg:mt-24">
                    <p className="mt-8 text-sm/6 text-gray-400 md:order-1 md:mt-0">
                        &copy; {formatDate({ time: _now(), formatStr: 'yyyy' })} Kilnworx Climbing Centre. All rights reserved.
                    </p>
                </div>
            </footer>

        </div>
    )
}

export default Wrapper;